import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import dayjs from 'dayjs';
import { inject, injectable } from 'inversify';
let CreditsService = class CreditsService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    getChargeModeLabel(chargeMode) {
        if (!chargeMode)
            return '';
        const labelMap = {
            COMMERCIAL: this.i18n.t('backoffice.company.credits.chargeModeCommercial'),
            TRIAL: this.i18n.t('backoffice.company.credits.chargeModeTrial'),
            FREE: this.i18n.t('backoffice.company.credits.chargeModeFree'),
            BETA: this.i18n.t('backoffice.company.credits.chargeModeBeta'),
            HISTORICAL: this.i18n.t('backoffice.company.credits.chargeModeHistorical'),
            INTERNAL: this.i18n.t('backoffice.company.credits.chargeModeInternal'),
            COOPERATIVE: this.i18n.t('backoffice.company.credits.chargeModeCooperative'),
            FREEMIUM: this.i18n.t('backoffice.company.credits.chargeModeFreemium'),
        };
        return labelMap[chargeMode] || chargeMode;
    }
    getChargeModeVariant(chargeMode) {
        const modeMap = {
            COMMERCIAL: 'success',
            TRIAL: 'warning',
            FREE: 'info',
            BETA: 'secondary',
        };
        return modeMap[chargeMode] || 'secondary';
    }
    isRechargeExpired(end) {
        if (end == null)
            return false;
        const endAt = dayjs(end);
        if (!endAt.isValid())
            return false;
        return dayjs().isAfter(endAt);
    }
};
CreditsService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object])
], CreditsService);
export { CreditsService };
